import React from 'react'
import _ from 'lodash'
import {
  ChecklistItem,
  Goal,
  GoalType,
  SingleGoalUpdate,
} from 'Generated/graphql-types'
import { showRecurringTasks, useAwsFlagActive } from 'Modules/FeatureFlag'
import { CommentList } from '../CommentList/CommentList'
import { ProgressChart } from '../ProgressChart/ProgressChart'
import { CampaignProgressChart } from '../CampaignProgressChart/CampaignProgressChart'
import TaskList from '../../../Dashboard/NonprofitPlatformDashboard/TaskList/TaskList'
import { GoalSectionParamOptions } from '../types'
import { TaskListWithTabs } from '../Tasks/TaskListV2/TasklistWithTabs'
import { UpdatesTab } from '../Updates/UpdatesTab'

type CurrentViewProps = {
  goal: Goal
  visibleSection: GoalSectionParamOptions
  tasks: ChecklistItem[]
  updates: SingleGoalUpdate[]
  updatesLoading: boolean
}

export const GoalSectionView = ({
  goal,
  visibleSection,
  tasks,
  updates,
  updatesLoading,
}: CurrentViewProps) => {
  const shouldShowRecurringTasks = useAwsFlagActive(showRecurringTasks)
  const comments = _.orderBy(
    goal.GoalUpdate.map((item) => item),
    'createdAt',
    'desc'
  )

  const funderSharedGoal = goal.FunderOrgToSharedGoal.filter(
    (sharedGoal) => sharedGoal.goalId === goal.id
  )[0]

  const goalIsSharedByFunder = funderSharedGoal?.isGoalSharedByFunder ?? false

  switch (visibleSection) {
    case 'comments':
      return (
        <CommentList
          comments={comments}
          goalId={goal.id}
          isGoalSharedWithFunder={!!funderSharedGoal}
        />
      )
    case 'progress':
      return goal.type === GoalType.Campaign ? (
        <CampaignProgressChart goal={goal} />
      ) : (
        <ProgressChart
          goal={goal}
          isGoalSharedWithFunder={!!funderSharedGoal}
          goalIsSharedByFunder={goalIsSharedByFunder}
        />
      )
    case 'updates':
      return (
        <UpdatesTab
          updates={updates}
          updatesLoading={updatesLoading}
          goalId={goal.id}
        />
      )
    default:
      return shouldShowRecurringTasks ? (
        <TaskListWithTabs goal={goal} />
      ) : (
        <TaskList
          items={tasks}
          eventProps={{
            goalId: goal.id,
            goalType: goal.type,
            templateLibraryId: goal.templateLibraryId ?? null,
            isGoalSharedWithFunder: !!funderSharedGoal,
          }}
        />
      )
  }
}
